<template>
<div class="join">
    <publicHead :background="bg" title="加入我们" en-title="JOIN US" @check="check" :list="['人才理念','招贤纳士']" :active="active"></publicHead>
    <div class="wrap">
        <div id="concept">
            <p class="child-title">人才理念</p>
            <p class="child-sub-title">TALENT CONCEPT</p>
            <div class="rc" v-for="(item, index) in rc" :key="index">
                <p class="name">{{item.name}}</p>
                <p class="desc">{{item.content}}</p>
            </div>
        </div>
        <div id="recruit">
            <p class="child-title">招贤纳士</p>
            <p class="child-sub-title">RECRUITMENT</p>
            <ul>
                <li v-for="(item, index) in zp.data" :key="index">
                    <div class="top" @click="changeZP(index)">
                        <div class="name">{{item.name}}</div>
                        <div class="other">{{item.city}} 丨 {{item.xl}} 丨 招{{item.num}}人</div>
                        <i :class="show!==index?'el-icon-plus':'el-icon-minus'"></i>
                    </div>
                    <div class="desc" v-show="show==index">
                        <p class="rich" v-html="item.content"></p>
                        <p class="type">联系我们</p>
                        <p class="options">
                            <i class="el-icon-phone"></i>
                            <span>电话：{{item.tel}}</span>
                            <i class="el-icon-message"></i>
                            <span>邮箱：{{item.yx}}</span>
                        </p>
                        <p class="type">我要应聘</p>
                        <p class="inps">
                            <span>姓名：</span>
                            <input type="text" name id v-model="form.name" />
                            <span>电话：</span>
                            <input type="number" name id v-model="form.tel" />
                            <span>应聘职位：</span>
                            <input type="text" name id v-model="form.zw" />
                        </p>
                        <button class="submit" @click="submit">提交</button>
                    </div>
                </li>
            </ul>
        </div>
        <el-pagination :page-size="6" background layout="prev, pager, next" :total="zp.total" @current-change="change"></el-pagination>
    </div>
</div>
</template>

<script>
import concept from "../components/join/concept";
import {
    rc,
    zp,
    bm
} from "../assets/js/api";
export default {
    components: {
        concept,
    },
    data() {
        return {
            bg: require("../assets/img/about-head.png"),
            active: 0,
            show: -1,
            rc: {},
            zp: {},
            page: 1,
            form: {},
        };
    },
    created() {
        rc().then((r) => {
            this.rc = r.data.data;
        });
        this.getData();
    },
    methods: {
        check(e) {
            if (e == 0) {
                document.getElementById("concept").scrollIntoView(true);
            } else if (e == 1) {
                document.getElementById("recruit").scrollIntoView(true);
            }
        },
        submit() {
            if (!this.form.name) {
                this.$message.error("请输入姓名");
                return false;
            }
            if (!this.form.tel) {
                this.$message.error("请输入电话");
                return false;
            }
            if (!this.form.zw) {
                this.$message.error("请输入职位");
                return false;
            }
            if (!/0?(13|14|15|17|18|19)[0-9]{9}/.test(this.form.tel)) {
                this.$message.error("请输入正确的手机号");
                return false;
            }
            bm(this.form).then((r) => {
                this.$message.success("成功");
                setTimeout(() => {
                    location.reload();
                }, 1500);
            });
        },
        changeZP(e) {
            this.show = this.show == e ? -1 : e;
            this.form.zp_id = this.zp.data[this.show].id;
        },
        change(e) {
            this.page = e;
            this.show = -1;
            this.getData();
        },
        getData() {
            zp({
                limit: 6,
                page: this.page,
            }).then((r) => {
                this.zp = r.data;
            });
        },
    },
};
</script>

<style lang="less" scoped>
.join {
    background: rgb(246, 246, 246);
}

.wrap {
    margin-top: 1.28rem;

    #concept {
        padding: 0.49rem 0.61rem;
        box-sizing: border-box;
        background: url("../assets/img/join-top.png") no-repeat;
        background-size: cover;

        .child-title {
            color: white;
        }

        .child-sub-title {
            color: white;
        }

        .rc {
            margin-bottom: 0.5rem;

            .name {
                font-size: 0.28rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ffffff;
                margin-bottom: 0.18rem;
            }

            .desc {
                font-size: 0.24rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
            }
        }
    }

    #recruit {
        margin-top: 0.75rem;

        li {
            margin-bottom: 0.25rem;

            .top {
                height: 1rem;
                width: 100%;
                background: #ededed;
                display: flex;
                align-items: center;
                justify-content: space-between;
                box-sizing: border-box;
                padding-left: 0.67rem;
                padding-right: 0.3rem;

                position: relative;

                .name {
                    width: 2.7rem;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // white-space: nowrap;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #3e3e3e;
                }

                .other {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #787878;
                    width: 2.7rem;
                }

                i {
                    font-size: 0.32rem;
                }
            }

            .desc {
                width: 100%;
                padding: 0.3rem;
                box-sizing: border-box;
                background: white;
                box-shadow: 0px 9px 13px 0px rgba(0, 0, 0, 0.15);

                .type {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    padding-left: 0.12rem;
                    border-left: 0.05rem solid #126fcc;
                    margin-bottom: 0.2rem;
                }

                .options {
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    margin: 0.181rem 0;

                    span {
                        margin-left: 0.12rem;
                        margin-right: 0.47rem;
                        display: inline-block;
                    }

                    i {
                        color: #126fcc;
                    }
                }

                .inps {
                    display: flex;
                    align-items: center;

                    font-size: 0.2rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;

                    input:nth-child(2) {
                        margin-right: 0.15rem;
                    }

                    input {
                        width: 1.2rem;
                        height: 0.5rem;

                        border: 1px solid #e5e5e5;
                        outline: none;
                    }

                    input:nth-child(4) {
                        margin-right: 0.5rem;
                    }
                }

                button {
                    width: 4.6rem;
                    height: 0.82rem;
                    background: #126fcc;
                    border-radius: 7px;
                    text-align: center;
                    line-height: 0.82rem;
                    text-align: center;
                    font-size: 0.3rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #ffffff;
                    border: none;
                    outline: none;
                    display: block;
                    margin: 0.78rem auto;
                }
            }
        }
    }
}
</style>
